<template>
    <div class="comp-footer-download"
         ref="downloadBox"
         v-clipboard="invitecode"
         v-if="showBanner === true">
        <!--<div class="close" @click="close">-->
            <!--<i class="iconfont icon-close"></i>-->
        <!--</div>-->
        <div class="left">
            <img src="../image/logo.png" alt="" height="48">
            <div class="text">
                <h5 class="title">{{messages[language].tweebaa}}</h5>
                <p>{{messages[language].downloadTips}}</p>
            </div>
        </div>
        <launch-app :type="type" :params="params">
            <div class="download-link">
                <a href="javascript:;" v-if="type === 'invite'">{{messages[language].download}}</a>
                <a href="javascript:;" v-else>{{messages[language].buttonText}}</a>
            </div>
        </launch-app>
    </div>
</template>
<script>
    import LaunchApp from '../components/LaunchApp.vue';
    export default {
        name: 'FooterDownload',
        props: {
            type: {
                type: String,
                default: ''
            },
            invitecode: {
                type: String,
                default: ''
            },
            params: {
                type: String,
                default: ''
            }
        },
        components: {
            LaunchApp
        },
        data() {
            return {
                showBanner: true,
                messages: {
                    en: {
                        tweebaa: 'Tweebaa',
                        downloadTips: 'Register now',
                        buttonText: 'Open In App',
                        download: 'Download'
                    },
                    zh: {
                        tweebaa: '推易吧',
                        downloadTips: '现在注册赚取更多奖励',
                        buttonText: '在App内打开',
                        download: '下载'
                    }
                }
            }
        },
        watch: {

        },
        created() {
            let ua = navigator.userAgent;
            if (ua.indexOf('baidu') > 0) {
                this.showBanner = false;
                window.setTimeout(() => {
                    this.showBanner = true;
                }, 1500);
            }
        },
        methods: {
            close() {
                this.showBanner = false;
            }
        }
    }
</script>
<style lang="less">
    .comp-footer-download {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 84px;
        background: #fff;
        padding-left: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        .close {
            position: absolute;
            left: 0.5rem;
            top: 50%;
            transform: translate(0, -50%);
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #677382;
        }
        .left {
            display: flex;
            flex: 1;
            .text {
                margin: 0 1rem;
                color: #677382;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .title {
                    font-size: 16px;
                    margin-bottom: 4px;
                }
                p {
                    font-size: 13px;
                    padding-right: 4px;
                    line-height: 1.5;
                }
            }
        }
        .download-link {
            margin-right: 1rem;
            a {
                padding: 8px 20px;
                background-color: @color-blue;
                border-radius: 20px;
                color: #fff;
                display: block;
                white-space: nowrap;
            }
        }
    }
</style>
